import React from 'react';

import { Result, Spin } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import { getLocationAlertErrorMessageId } from '../../locationAlert.utils';
import { useMainAlert } from './hooks/useMainAlert';
import styles from './styles.module.less';

const MainAlert = () => {
  const { error, loading } = useMainAlert();

  if (loading) {
    return (
      <div className={styles.mainAlertLoading}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.mainAlertLoading}>
        <Result
          status="error"
          title={<IntlMessages id="location.alert.error.title" />}
          subTitle={<IntlMessages id={getLocationAlertErrorMessageId(error)} />}
        />
      </div>
    );
  }

  return null;
};

export default MainAlert;
